import { createFileRoute } from "@tanstack/react-router";
import Reservations from "@/pages/admin/Reservations";

export const Route = createFileRoute("/admin/reservations")({
  component: Reservations,
});
